import React, { useRef, FC, useEffect } from "react";
import styled from "styled-components";
import { ElBotton } from "../../../components/common/ElBotton";

import diplomabase from './diploma-bazi_2024.jpeg';

type DiplomaBazi2024 = {
  nombre: string;
  generacion: string;
};

export const Bazi2024: FC<DiplomaBazi2024> = ({
  nombre,
  generacion,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    function generar() {
      if (!canvasRef.current) return;

      const context = canvasRef.current.getContext("2d");
      const diploma = new Image();
      diploma.crossOrigin = "anonymous"

      diploma.onload = function () {
        if (!context) return;
        context.drawImage(diploma, 0, 0);
        context.font = "52pt serif";
        context.fillText(nombre, 300, 640); //posicion

        context.font = "32pt sans-serif";
      };

      diploma.src = diplomabase;
    }

    generar();
  }, [generacion, nombre]);

  function download() {
    var link = document.createElement("a");
    link.download = "diploma.png";
    link.href = canvasRef?.current?.toDataURL() as string;
    link.click();
  }

  return (
    <Wrapper>
      <canvas
        width={1600}
        height={1500}
        ref={canvasRef}
        style={{ width: "688px", height: "auto" }}
      ></canvas>
      <ElBotton onClick={download}>descargar</ElBotton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 20px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
